import { putAndWaitHandleAllAPIError } from '@api/API.sagas';
import { API_GET_ACCOUNTS } from '@api/lendingAPI/LendingAPI.actions';
import { getCurrentLocation } from '@iwRouter/HistoryProvider';
import { fork, put, takeLatest } from 'redux-saga/effects';
import { createWorkersForPage } from '../pageStructure/routerWorkers/PageWorkerFactory.sagas';
import { chooseRepaymentAmountSagaWorkers } from './chooseRepaymentAmount/ChooseRepaymentAmount.sagas';
import { confirmRepaymentSagaWorkers } from './confirmRepayment/ConfirmRepayment.sagas';
import {
    ACCEPT_TRUELAYER_REDIRECT,
    ACTIVATE_EARLY_REPAYMENT,
    EARLY_REPAYMENT_LOADING,
    SHOW_CHOOSE_REPAYMENT_AMOUNT_STEP,
    SHOW_CONFIRM_REPAYMENT_STEP,
    SHOW_TRUELAYER_CONFIRMATION
} from './EarlyRepayment.actions';
import {
    getEarlyRepaymentURLData,
    isEarlyRepaymentLocation
} from './EarlyRepaymentHelper';
import { truelayerSagaWorkers } from './truelayer/Truelayer.sagas';

export const earlyRepaymentSagaWorkers = createWorkersForPage({
    page: 'EARLY_REPAYMENT',
    isInPageLocation: isEarlyRepaymentLocation,
    createPageFlowWorkers: () => [
        fork(earlyRepaymentPageWorker),
        ...chooseRepaymentAmountSagaWorkers,
        ...confirmRepaymentSagaWorkers,
        ...truelayerSagaWorkers
    ]
});

function* earlyRepaymentPageWorker() {
    yield takeLatest(ACTIVATE_EARLY_REPAYMENT, function* () {
        yield put({ type: EARLY_REPAYMENT_LOADING });

        yield putAndWaitHandleAllAPIError([{ type: API_GET_ACCOUNTS }]);

        const currentLocation = getCurrentLocation();
        const urlData = getEarlyRepaymentURLData(currentLocation);

        switch (urlData.step) {
            case 'CHOOSE_REPAYMENT_AMOUNT':
            default:
                yield put({ type: SHOW_CHOOSE_REPAYMENT_AMOUNT_STEP });
                break;
            case 'CONFIRM_REPAYMENT':
                yield put({ type: SHOW_CONFIRM_REPAYMENT_STEP });
                break;
            case 'ACCEPT_TRUELAYER_REDIRECT':
                yield put({ type: ACCEPT_TRUELAYER_REDIRECT });
                break;
            case 'SHOW_TRUELAYER_CONFIRMATION':
                yield put({ type: SHOW_TRUELAYER_CONFIRMATION });
                break;
        }
    });
}
